import { Box, Theme, useTheme } from "@mui/material";
import { SxProps } from '@mui/system';
import React, { FormEventHandler, PropsWithChildren, type JSX } from 'react';
import { FieldPath, FieldValues, FormProvider, UseFormReturn } from "react-hook-form";

export type FormFieldPropsBase<TFieldValues extends FieldValues = FieldValues, TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>> = {
    name: TName;
    id?: string;
    testId?: string;
    label?: string | JSX.Element | null;
    ariaLabel?: string | null;
    readOnly?: boolean;
    helperText?: string | JSX.Element | null;
    sx?: SxProps<Theme>;
    disabled?: boolean;
    size?: 'small' | 'medium';
    shouldUnregister?: boolean;
    showID?: boolean;
};

export type FormProps<T extends FieldValues> = {
    form: UseFormReturn<T>;
    sx?: SxProps<Theme>;
    onSubmit?: FormEventHandler;
    hideFormScroll?: boolean
};

export default function Form<T extends FieldValues>({ form, sx, onSubmit, hideFormScroll, children }: PropsWithChildren<FormProps<T>>) {
    const theme = useTheme();

    return (
        <FormProvider {...form}>
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                padding: theme.spacing(1),
                flex: '1 1 auto',
                overflow: 'hidden',
                ...sx
            }}>
                {/* there will be a warning for setting the role here, but, without it the role attribute is not present */}
                {/* eslint-disable-next-line */}
                <form role='form'
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        //padding: theme.spacing(1),
                        flex: '1 1 auto',
                        overflow: 'hidden',
                        overflowY: hideFormScroll ? 'hidden' : 'auto',

                    }}
                    onSubmit={onSubmit} noValidate>
                    {children}
                </form>
            </Box>
        </FormProvider>
    );
}


